import { SetBootstrapVersion } from 'smg/bootstrap';
import { SetIconLibrary } from 'smg/icons';
import * as errors from 'smg/errors';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as carts from './carts';
import * as session from 'smg/customer-api/session';
import { Init as InitToast } from './toast';

SetIconLibrary('fontAwesome4');
SetBootstrapVersion(4);
InitToast();

errors.InitClientSideErrorLogging();
// Page tracking and the cart count both wait for any ?loginToken= exchange, so
// the page request and the count belong to the account the link signed in.
void session.ConsumeLoginTokenFromURL().then(() => {
    void GetPageRequestID();
    return carts.GetCartCount();
}).then(count => {
    if (count) {
        carts.SetCartCount(count);
    }
});

// Prices themselves are rendered at build time from data/pricecatalog.json; only
// the size/quantity selector needs behavior, and it appears across many
// product-type layouts and shortcodes rather than one page. Lazy-load the wiring
// only when a selector is on the page.
if (document.querySelector('.pricing-table-container')) {
    void import('./pricing-table').then(pricingTable => pricingTable.PricingTable());
}
